import React from 'react';
import { Placeholder, RouteData, ComponentRendering } from '@sitecore-jss/sitecore-jss-react';
import { Container, Grid } from '@material-ui/core';
import './index.scss';

type RenderingProps = {
  rendering: RouteData | ComponentRendering;
};

const SectionFullWidth = ({ rendering }: RenderingProps) => {
  return (
    <Container className="section-full-width" maxWidth={false} disableGutters>
      <Grid>
        <Grid item>
          <Placeholder name="section_full_width" rendering={rendering} />
        </Grid>
      </Grid>
    </Container>
  );
};

export default SectionFullWidth;
